import { FC, memo } from 'react'

import { ProjectListTable } from 'src/components/organisms'

import { useGetProfile } from 'src/hooks'
import { ProjectEntity } from 'src/types'

type Props = {
  projects: ProjectEntity[]
  isLoading: boolean
  className?: string
}

export const ProjectList: FC<Props> = memo(({ projects, isLoading, className }) => {
  const { loading: isProfileLoading, profile } = useGetProfile()

  return (
    <div className={className}>
      {/* プロジェクト一覧は横に長いため横スクロール可能にする */}
      <div className="tw-w-full tw-overflow-auto">
        <ProjectListTable
          projects={projects}
          profile={profile}
          isLoading={isLoading || isProfileLoading}
          className="tw-min-w-[70rem]"
        />
      </div>
    </div>
  )
})
